export default "__VITE_ASSET__19930a81__"